<template>
    <div>
        <v-text-field label="GS1コード"
                      v-bind:value="value"
                      v-on:input="(x) => $emit('input', x)"
                      @blur="onBlur"
                      @keydown.enter="onEnter"
                      clearable
                      maxlength="14">
            <template v-slot:append>
                <span class="mx-2 my-code-name" v-if="selected_item != null">{{ selected_item.product_name }}</span>
                <v-btn icon color="primary darken-3" style="text-align:center;" small
                       v-on:click="dialog = true">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

        </v-text-field>

        <v-dialog v-model="dialog" max-width="80%" >
            <v-card>
                <v-card-title class="headline">商品一覧</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field label="商品名 全角" v-model="search.product_name" clearable></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field label="メーカー名 全角" v-model="search.manufacturer_name" clearable></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field label="規格名 全角" v-model="search.standard_name" clearable></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <span>
                                    対象件数{{searchCnt}}件
                                </span>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="onSearch">検索</v-btn>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="dialog = false">閉じる</v-btn>

                            </v-col>
                        </v-row>
                        
                        <v-data-table dense class="grey lighten-4"
                                      :headers="product_list_headers"
                                      :items="product_list"
                                      no-data-text="対象データがみつかりませんでした">
                            <template v-slot:item.action="{ item }">
                                <v-btn class="mx-2" color="primary darken-3" dark @click="onSelectRow(item)">選択</v-btn>
                            </template>
                        </v-data-table>
                    </v-container>

                </v-card-text>
            </v-card>

        </v-dialog>

    </div>
    
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        props: ['value'],
        components: {
        },
        watch: {
            value: function (val) {
                if (val !== this.selected_item.gs1_code_1) {
                    this.selected_item = null;
                }
            },
            selected_item: function (val) {
                this.$emit('onChangeProduct', val);
            }
        },
        computed: {
            ...mapState({
                state: state => state
            })
        },
        data: () => ({
            dialog: false,
            searchCnt: 0,
            search: {
                product_name: "",
                manufacturer_name: "",
                standard_name: ""
            },
            selected_product_name: "",
            product_list: [],
            selected_item: null,
            product_list_headers: [
                { text: '', value: 'action', filterable: false, sortable: false, width: 120 },
                { text: 'GS1コード', value: 'gs1_code_1', filterable: false, width: 130 },
                { text: '商品名', value: 'product_name', filterable: false, width: 250 },
                { text: '規格名', value: 'standard_name', width: 150 },
                { text: 'メーカー名', value: 'manufacturer_name', width: 150 },
                { text: 'JANコード', value: 'jan_code', width: 350 }
            ]
        }),
        mounted: function () {
            this.$nextTick(function () {
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                //this.onGetCnt();
                //this.onSearch();
            })

        },
        methods: {
            onSelectRow(item) {
                this.selected_item = item;
                this.$emit('input', item.gs1_code_1);
                this.dialog = false;
            },
            onGetCnt() {

                var buf = [];
                for (var i in this.state.products) {
                    var item = this.state.products[i];

                    if (item.product_name.includes(this.search.product_name)) {
                        buf.push(item);
                    }
                }

                this.searchCnt = buf.length;
            },
            onEnter(e) {
                if (e.keyCode !== 13) return;

                this.value = this.value.trim();
                this.getProductItem();
            },
            onBlur() {
                console.log('onBlur');
                this.value = this.value.trim();
                this.getProductItem();
            },
            getProductItem() {
                for (var i in this.state.products) {
                    var item = this.state.products[i];
                    if (item.gs1_code_1 == this.value) {
                        this.selected_item = item;
                        this.$emit('input', item.gs1_code_1);
                        break;
                    }
                }
            },
            onSearch() {

                if (this.search.product_name == null) {
                    this.search.product_name = "";
                }
                if (this.search.manufacturer_name == null) {
                    this.search.manufacturer_name = "";
                }
                if (this.search.standard_name == null) {
                    this.search.standard_name = "";
                }

                this.product_list = [];
                var buf = [];
                for (var i in this.state.products) {
                    var item = this.state.products[i];

                    if (item.product_name?.includes(this.search.product_name)
                        && item.manufacturer_name?.includes(this.search.manufacturer_name)
                        && item.standard_name?.includes(this.search.standard_name)) {
                        buf.push(item);
                    }
                }

                this.searchCnt = buf.length;

                for (i in buf) {
                    item = buf[i];
                    this.product_list.push(item);
                }
            },
        }
    }
</script>

<style>
    .my-code-name {
        padding: 6px 0 8px;
    }
</style>
<style scoped>
    .v-data-table {
        white-space: nowrap;
    }
</style>